var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDashboardEmpty = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 96,
  height: 96,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 48,
  r: 48,
  fill: "#4C5773",
  fillOpacity: 0.05
}), /*#__PURE__*/React.createElement("path", {
  d: "M24 35a4 4 0 0 1 4-4h40a4 4 0 0 1 4 4v26a4 4 0 0 1-4 4H28a4 4 0 0 1-4-4V35Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.375 35A4.625 4.625 0 0 1 28 30.375h40A4.625 4.625 0 0 1 72.625 35v26A4.625 4.625 0 0 1 68 65.625H28A4.625 4.625 0 0 1 23.375 61V35ZM28 31.625A3.375 3.375 0 0 0 24.625 35v26A3.375 3.375 0 0 0 28 64.375h40A3.375 3.375 0 0 0 71.375 61V35A3.375 3.375 0 0 0 68 31.625H28Z",
  fill: "#949AAB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.5 38a1.5 1.5 0 0 1 1.5-1.5h34a1.5 1.5 0 0 1 1.5 1.5v17a1.5 1.5 0 0 1-1.5 1.5H31a1.5 1.5 0 0 1-1.5-1.5V38Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.875 38c0-1.174.951-2.125 2.125-2.125h34c1.174 0 2.125.951 2.125 2.125v17A2.125 2.125 0 0 1 65 57.125H31A2.125 2.125 0 0 1 28.875 55V38ZM31 37.125a.875.875 0 0 0-.875.875v17c0 .483.392.875.875.875h34a.875.875 0 0 0 .875-.875V38a.875.875 0 0 0-.875-.875H31ZM61.071 61.179a.464.464 0 1 0 0-.93.464.464 0 0 0 0 .93Zm0 1.25a1.714 1.714 0 1 0 0-3.429 1.714 1.714 0 0 0 0 3.429ZM65.571 61.179a.464.464 0 1 0 0-.93.464.464 0 0 0 0 .93Zm0 1.25a1.714 1.714 0 1 0 0-3.429 1.714 1.714 0 0 0 0 3.429Z",
  fill: "#949AAB"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 43.5,
  r: 1.5,
  fill: "#949AAB"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 43.5,
  r: 1.5,
  fill: "#949AAB"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M46.833 48.725c.27.249.67.4 1.167.4s.898-.151 1.167-.4c.261-.241.458-.628.458-1.225h1.25c0 .894-.307 1.633-.86 2.143-.545.504-1.27.732-2.015.732-.745 0-1.47-.228-2.015-.732-.553-.51-.86-1.249-.86-2.143h1.25c0 .597.197.984.458 1.225Z",
  fill: "#949AAB"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.1,
  d: "m58.48 26.667 23.182 6.212-4.14 15.455-23.183-6.212z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m58.48 22.667 23.182 6.212-4.141 15.454-23.183-6.211 4.142-15.455Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M57.876 22.505a.625.625 0 0 1 .765-.442l23.182 6.212c.334.09.532.432.443.765l-4.142 15.455a.625.625 0 0 1-.765.442l-23.182-6.212a.625.625 0 0 1-.442-.765l4.14-15.455Zm1.046.927L55.104 37.68l21.975 5.888 3.817-14.248-21.974-5.888Z",
  fill: "#949AAB"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.5,
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#949AAB"
}, /*#__PURE__*/React.createElement("path", {
  d: "m59.462 36.389 2.588-9.66 1.207.324-2.588 9.659-1.207-.324ZM63.808 37.553l1.553-5.795 1.208.323-1.553 5.796-1.208-.324ZM68.155 38.718l1.035-3.864 1.208.324-1.036 3.863-1.207-.323ZM72.502 39.883l1.553-5.795 1.207.323-1.553 5.796-1.207-.324Z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M24 65a8 8 0 1 0 0-16v8h-8a8 8 0 0 0 8 8Z",
  fill: "#000",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M24 61a8 8 0 1 0 0-16v8h-8a8 8 0 0 0 8 8Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.375 45c0-.345.28-.625.625-.625A8.625 8.625 0 1 1 15.375 53c0-.345.28-.625.625-.625h7.375V45Zm1.25.651V53c0 .345-.28.625-.625.625h-7.349a7.376 7.376 0 1 0 7.974-7.974Z",
  fill: "#949AAB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.5 45a5.5 5.5 0 0 0-5.5 5.5h5.5V45Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.665 49.875h4.21v-4.21a4.878 4.878 0 0 0-4.21 4.21Zm-1.29.625a6.125 6.125 0 0 1 6.125-6.125c.345 0 .625.28.625.625v5.5c0 .345-.28.625-.625.625H16a.625.625 0 0 1-.625-.625Z",
  fill: "#949AAB"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h96v96H0z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDashboardEmpty);
export default ForwardRef;